'use client';

import { Badge, Box, Divider, Group, Stack, Text, Title } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';
import Showdown from 'showdown';

import { formatVersionDate } from '@/utils/version-parser';

const converter = new Showdown.Converter();

function MarkdownContent({ value }: { value: string }) {
  return <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(value) }} />;
}

import type { VersionContent } from '@/typings/version';

type ReleaseNotesContentProps = {
  versions: VersionContent[];
};

export const ReleaseNotesContent: React.FC<ReleaseNotesContentProps> = ({ versions }) => {
  if (versions.length === 0) {
    return (
      <Box py="xl">
        <Text c="dimmed" ta="center">
          Nenhuma versão disponível
        </Text>
      </Box>
    );
  }

  return (
    <Stack gap="md">
      {versions.map((version, index) => (
        <VersionCard key={version.metadata.version} version={version} isLatest={index === 0} />
      ))}
    </Stack>
  );
};

type VersionCardProps = {
  version: VersionContent;
  isLatest: boolean;
};

const VersionCard: React.FC<VersionCardProps> = ({ version, isLatest }) => {
  return (
    <Box>
      {isLatest && (
        <Box mb="md">
          <Group gap="sm" mb="xs">
            <Title order={2} fw={700}>
              Versão {version.metadata.version}
            </Title>
            <Badge variant="gradient" size="lg">
              Versão Atual
            </Badge>
          </Group>
          <Text size="sm" c="dimmed">
            {formatVersionDate(version.metadata.date)}
          </Text>
        </Box>
      )}
      {!isLatest && (
        <>
          <Group gap="xs" mb="md">
            <IconHistory size={20} />
            <Title order={3}>Versão {version.metadata.version}</Title>
            <Text size="sm" c="dimmed">
              • {formatVersionDate(version.metadata.date)}
            </Text>
          </Group>
          <Divider my="md" />
        </>
      )}

      <MarkdownContent value={version.content} />

      {!isLatest && <Divider my="xl" />}
    </Box>
  );
};
